/**
 * Supported locales for the Clari customer-facing product (apps/web).
 *
 * Order matters for fallback chains: `en` is the technical fallback
 * (the language of the API/error contracts), `fr` is the founder's
 * language, then `ar`/`es` for the launch markets, then `de`/`it`/`pt`/`nl`/`pl`
 * to cover ~95% of the EU population plus diaspora reach.
 *
 * The admin console intentionally ships only FR/EN (see apps/admin/src/lib/i18n.ts)
 * to keep operator/audit vocabulary consistent for ACPR reviewers.
 *
 * See CLAUDE.md §10 for the full multilingual strategy.
 */
export const SUPPORTED_LOCALES = [
    'fr',
    'en',
    'ar',
    'es',
    'de',
    'it',
    'pt',
    'nl',
    'pl',
];
export const DEFAULT_LOCALE = 'en';
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
/**
 * Native (endonym) name for each supported locale.
 *
 * Used by the LanguageSwitcher so users see their language in their own
 * script — research and our own audits show endonym labels lift switch-rate
 * dramatically vs. ISO codes ("AR" → "العربية", "PL" → "Polski").
 */
export const LOCALE_NATIVE_NAMES = {
    fr: 'Français',
    en: 'English',
    ar: 'العربية',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    nl: 'Nederlands',
    pl: 'Polski',
};
export { NAMESPACES } from './namespaces.js';
export { RTL_LOCALES, isRTL, getDir } from './rtl.js';
//# sourceMappingURL=index.js.map